$(() => {
  // table のコメントセルをクリックで、セル高さを広げる/縮める
  $('.toggle-max-height-60').on('click', function () {
    const maxHeight = '60px';
    const curMaxHeight = $(this).css('max-height');

    if (curMaxHeight == 'none') {
      $(this).css('max-height', maxHeight);
    } else {
      $(this).css('max-height', 'none');
     }
  });

  // 削除ボタンをクリックで、コメントを削除
  $('.comment-delete-button').on('click', function () {
    const commentId = $(this).data('comment-id');
    const commentEditor = $('#comment-editor');
    const commentEditButton = $(this).prev('.comment-edit-button');
    const commentDeleteButton = $(this);

    if (confirm('本当に削除しますか？')) {
      $.ajaxSetup({
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
      });

      $.ajax({
        url: '/saas_editing_comments/' + commentId,
        type: 'DELETE',
        data: {
          saas_editing_comment: {},
        },
        dataType: 'json',
      }).done(function (data) {
        const commentBodyDiv = $("#comment-body-div-" + commentId);

        commentBodyDiv.text('<<コメントは削除されました。>>');
        commentEditor.hide();
        commentEditButton.hide();
        commentDeleteButton.hide();
      });
    } else {
        return false
    }
  });

  // 編集ボタンをクリックで、コメント編集エリアに選択されたコメントをコピー＆編集エリア表示
  $('.comment-edit-button').on('click', function () {
    const commentId = $(this).data('comment-id');
    const commentBody = $(this).data('original-body');
    const commentEditor = $('#comment-editor');
    const commentTextarea = $('#comment_body');
    const commentUpdateButton = $('#comment-editor-buttons').children('.editor-update-button');
    const commentPostError = $("#comment-editor-post-error");

    commentTextarea.val(commentBody);
    commentUpdateButton.data('update-id', commentId);
    commentPostError.hide();
    commentEditor.show();
    commentTextarea.focus();
  });

  // キャンセルボタンをクリックで、編集エリアを非表示
  $('.editor-cancel-button').on('click', function () {
    const commentEditor = $('#comment-editor');
    const commentTextarea = $('#comment_body');

    commentEditor.hide();
    commentTextarea.val('');
  });

  // 更新ボタンをクリックで、コメントを更新
  $('.editor-update-button').on('click', function () {
    const commentId = $(this).data('update-id');
    const commentTextarea = $('#comment_body');
    const commentBody = commentTextarea.val();

    $.ajaxSetup({
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    });

    $.ajax({
      url: '/saas_editing_comments/' + commentId,
      type: 'PATCH',
      data: {
        saas_editing_comment: {
          body: commentBody
        },
      },
      dataType: 'json',
    }).done(function (data) {
      const commentPostError = $("#comment-editor-post-error");

      if (data.error) {
        commentPostError.text('コメントの更新に失敗しました。' + data.error);
        commentPostError.show();
      } else {
        const commentBodyDiv = $("#comment-body-div-" + data.id);
        const commentEditor = $('#comment-editor');
        const commentTextarea = $('#comment_body');
        const displayBody = data.body;
        const editedAt = new Date(data.edited_at);
        const commentEditButton = $('.comment-edit-button[data-comment-id="'+data.id+'"]');
        const year = editedAt.getFullYear();
        const month = ('0' + (editedAt.getMonth() + 1)).slice(-2);
        const day = ('0' + editedAt.getDate()).slice(-2);
        const hour = ('0' + editedAt.getHours()).slice(-2);
        const min = ('0' + editedAt.getMinutes()).slice(-2);
        const editedStr = `\n<<編集済み ${year}年${month}月${day}日 ${hour}:${min}>>`;

        commentPostError.hide();
        commentPostError.text('');
        commentBodyDiv.text(displayBody + editedStr);
        commentEditButton.data('original-body', displayBody);
        commentEditor.hide();
        commentTextarea.val('');
      }
    });
  });
});
